import { useMemo } from "react";
import { ListLocationDto } from "../models/location.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredLocations(locations: ListLocationDto[]) {
	const { query } = useSearch();

	const filteredLocations = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return locations?.filter(loc => 
				(loc.Title && loc.Title.toLowerCase().includes(lowerQuery))) || [];
		} else {
			return locations || [];
		}
	}, [query, locations]);

	return { filteredLocations, showNoResults: query && query.length > 0 && filteredLocations.length === 0 };
}